import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 422,
  name: 'Unprocessable Entity',
  description:
    'The server understands the request format but cannot process the contained instructions. The syntax is correct (not a 400), but the content fails semantic validation — like submitting a form with an invalid email address.',
  causes: [
    'Form validation failed — required fields are missing, an email format is invalid, a number is out of range, or a string exceeds the max length.',
    'Business logic validation failed — for example, setting an end date before the start date, or referencing a foreign key that does not exist.',
    'The request body is syntactically valid JSON but contains fields with the wrong data types (string instead of number, null where required).',
  ],
  fixes: [
    'Read the response body. APIs that return 422 almost always include field-level error messages explaining what failed validation.',
    'Add client-side validation to catch these errors before submitting. Validate required fields, formats, and ranges in the form.',
    'If the validation rules changed server-side, update your client to match the new requirements. Check API changelog or documentation.',
  ],
  monitoringTip:
    'A spike in 422 errors from your API may mean validation rules changed in a deploy and clients are sending data the server now rejects. Uptrack helps you catch these regressions.',
}

export const Route = createFileRoute('/_site/http/422')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
